import {
  SEND_NOTIFICATION,
  RECEIVE_NOTIFICATION,
  RECEIVE_NOTIFICATION_HISTORY,
  SUBSCRIBE_NOTIFICATION,
  UNSUBSCRIBE_NOTIFICATION,
} from "constants/actionTypes";

import { notificationService } from "services";

export const notificationActions = {
  fetch,
  send,
  subscribe,
  unsubscribe,
};

function fetch(page_number, per_page = 10) {
  return function (dispatch, getState) {
    const { user } = getState();
    const userId = user.infos && user.infos.id;
    notificationService.list({ page_number, per_page }).then((pagedData) => {
      // console.log('coucou store.notifications')
      dispatch(receiveHistory(pagedData));
    });
  };
}

function send(message, toUserId) {
  return function (dispatch) {
    notificationService.send({ message }, toUserId);
    dispatch({ type: SEND_NOTIFICATION });
  };
}

function receive(message) {
  return function (dispatch) {
    dispatch({ type: RECEIVE_NOTIFICATION, payload: { ...message, _isRealTime: true } });
  };
}

function receiveHistory(pagedData) {
  const { per_page, page, total, unseen_count, data } = pagedData;
  return function (dispatch) {
    dispatch({
      type: RECEIVE_NOTIFICATION_HISTORY,
      payload: { receivedMeta: { per_page, page, total, unseen_count }, received: data },
    });
  };
}

function subscribe() {
  return function (dispatch, getState) {
    const {
      notifications: { subscribed },
      user,
    } = getState();
    if (subscribed) return;
    const userId = user.infos && user.infos.id;
    notificationService.createConsumer(userId);
    notificationService.subscribe(function (data) {
      dispatch(receive(data));
    });
    dispatch({ type: SUBSCRIBE_NOTIFICATION });
  };
}

function unsubscribe() {
  return function (dispatch, getState) {
    const {
      notifications: { subscribed },
      user,
    } = getState();
    if (!subscribed) return;
    notificationService.unsubscribe();
    notificationService.destroy();
    dispatch({ type: UNSUBSCRIBE_NOTIFICATION });
  };
}
